import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const NotFoundPage = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 pt-20">
            <SEOHead title="404 - Page Not Found" noindex={true} />

            <div className="max-w-md w-full text-center">
                <div className="mb-8 relative">
                    <h1 className="text-9xl font-display font-black text-gray-200">404</h1>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-3xl font-bold text-brand-blue translate-y-4">Oops! Lost in Comfort?</h2>
                    </div>
                </div>

                <p className="text-gray-600 mb-10 text-lg">
                    It seems the page you're looking for has drifted away. Don't worry, your perfect night's sleep is still just a click away.
                </p>

                <div className="space-y-4">
                    <Link
                        to="/"
                        className="block w-full bg-brand-blue hover:bg-brand-red text-white font-bold py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                        Back to Home
                    </Link>
                    <Link
                        to="/products"
                        className="block w-full bg-white border-2 border-brand-blue text-brand-blue hover:bg-blue-50 font-bold py-4 rounded-xl transition-all duration-300"
                    >
                        Browse Collection
                    </Link>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-200">
                    <p className="text-sm text-gray-500 italic">
                        "Everything is better after a good night's sleep."
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
